/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `video` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class VideoMesg : Mesg {
    public constructor() : super("Video", Profile.MesgNum.VIDEO)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** url. */
    public var url: String?
        get() = getFieldValue(URL_FIELD_NUM) as? String
        set(value) = setFieldValue(URL_FIELD_NUM, value)

    /** hosting_provider. */
    public var hostingProvider: String?
        get() = getFieldValue(HOSTING_PROVIDER_FIELD_NUM) as? String
        set(value) = setFieldValue(HOSTING_PROVIDER_FIELD_NUM, value)

    /** duration, in ms. Playback time of video */
    public var duration: UInt?
        get() = getFieldValue(DURATION_FIELD_NUM) as? UInt
        set(value) = setFieldValue(DURATION_FIELD_NUM, value)

    public companion object {
        public const val URL_FIELD_NUM: UByte = 0u
        public const val HOSTING_PROVIDER_FIELD_NUM: UByte = 1u
        public const val DURATION_FIELD_NUM: UByte = 2u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("Url", 0u, BaseType.STRING, 1.0, 0.0, "", false)
            fields[1] = Field("HostingProvider", 1u, BaseType.STRING, 1.0, 0.0, "", false)
            fields[2] = Field("Duration", 2u, BaseType.UINT32, 1.0, 0.0, "ms", false)
            return fields
        }
    }
}
